import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { AllowanceWiseClaimManagementJson } from "../../DynamicFormsJson/MastersJSON/AllowanceWiseClaimManagement";
import { getBelowSalesTeamList, getAllSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import endpoint from "../../config/endpoints";
import {
    approveClaimMsg,
    approvedSuccessfullyMsg,
    attachementMsg,
    attachementSuccessMsg,
    checkedListEmptyMsg,
    checkRequiredFieldsMsg,
    deleteFailedMsg,
    deletemsg,
    deleteWarningMsgForClaim,
    noInternetMsg,
    rejectClaimMsg,
    rejectedSuccessfullyMsg,
    saveFailedMsg,
    savemsg,
    saveWarningMsg,
    saveWarningMsgForClaimManagement,
    selectPendingClaimMsg,
    serverMsg,
    statusmsg,
    thisFieldIsRequiredMsg
} from "../../config/messageconstant";
import { apiDelete, apiGet, apiPost, apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import AllowanceWiseClaimManagementTable from "./AllowanceWiseClaimManagementTable";
import NormalClaimManagementTable from "./NormalClaimManagementTable";
import { mandatoryCheck } from "../../config/ValidationCheck";
import dayjs from "dayjs";
import AttachementPopUp from "./AttachementPopUp";

class AllowanceWiseClaimManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
            },
            searchValue: "",
            salesTeamId: "",
            fromDate: "",
            toDate: "",
            matrixDataList: [],
            allChecked: false,
            claimType: 0,
            fieldData: { claimType: "0" },
            formErrors: {},
            normalClaimListData: [],
            formErrorForDetails: {},
            attachmentPopUpFlag: false,
            rows: [],
            rowId: "",
            ratePerKm: 0,
        };
    }

    async componentDidMount() {
        const { getAllSalesExecutiveByUserType, getBelowSalesTeamList, showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {
            const userTypeId = localStorage.getItem("userTypeId");

            if (userTypeId && (userTypeId == 1 || userTypeId == 6)) {
                showLoador({ loador: true });
                await getAllSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
                    ({ success, response }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            } else if (userTypeId && userTypeId == 3) {
                showLoador({ loador: true });
                await getBelowSalesTeamList({ salesTeamId, flag: "1" }).then(
                    ({ success, response }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.salesPersonList !== nextProps.salesPersonList) {
            if (
                this.props.salesPersonList?.salesPersonByArea !==
                nextProps.salesPersonList?.salesPersonByArea
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
                    },
                });
            }
        }
    }


    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: AllowanceWiseClaimManagementJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    dateComparisonCheck = () => {
        let formValid = true;
        const { fieldData } = this.state;

        let formErrors = {};
        AllowanceWiseClaimManagementJson.fieldMeta.forEach((currentField) => {
            if (currentField.onSubmit === "compare") {
                const onSubmitParameter = currentField.onSubmitParameter;
                if (onSubmitParameter) {
                    const compareWith = onSubmitParameter.split("-")[0].trim();
                    const compareCond = onSubmitParameter.split("-")[1].trim();
                    let isError = false;
                    let condErrorText = "";

                    let dataKeyValue = fieldData[currentField.dataKey];
                    let compareWithValue = fieldData[compareWith];
                    let fromDate = fieldData[currentField.dataKey];
                    let toDate = fieldData[compareWith];

                    if (fromDate && toDate) {
                        if (typeof fromDate === "string") {
                            const dateArr = fromDate?.split("-");

                            dataKeyValue = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
                        }
                        if (typeof toDate === "string") {
                            const dateArr = toDate?.split("-");

                            compareWithValue = new Date(
                                dateArr[0],
                                dateArr[1] - 1,
                                dateArr[2]
                            );
                        }
                        switch (compareCond) {
                            case "l":
                                if (!(dataKeyValue < compareWithValue)) {
                                    isError = true;
                                    condErrorText = "less than";
                                }

                                break;
                            case "le":
                                if (!(dataKeyValue <= compareWithValue)) {
                                    isError = true;
                                    condErrorText = "less than equal to";
                                }

                                break;
                            case "g":
                                if (!(dataKeyValue > compareWithValue)) {
                                    isError = true;
                                    condErrorText = "greater than";
                                }

                                break;
                            case "ge":
                                if (!(dataKeyValue >= compareWithValue)) {
                                    isError = true;
                                    condErrorText = "greater than equal to";
                                }

                                break;
                            case "eq":
                                if (!(dataKeyValue === compareWithValue)) {
                                    isError = true;
                                    condErrorText = "equal to";
                                }

                                break;
                            default:
                                break;
                        }

                        if (isError) {
                            const compareWithFieldLabel = AllowanceWiseClaimManagementJson.fieldMeta.filter(
                                (item) => item.dataKey === compareWith
                            )[0].label;
                            formValid = false;
                            formErrors = {
                                ...formErrors,
                                [currentField.dataKey]: {
                                    isError: true,
                                    errorText: `${currentField.label} should be ${condErrorText} ${compareWithFieldLabel}`,
                                },
                            };
                        }
                    }
                }
            }
        });
        this.setState({
            formErrors: formErrors,
        });
        return formValid;
    };


    onAddImage = (fileName) => {
        const { rows, rowId, normalClaimListData } = this.state;

        const { showLoador, showNotification } = this.props;


        if (fileName === null || fileName === undefined || fileName === "") {
            return showNotification({ msg: "Please add attachement", severity: "error" });
        }

        let fileNameData = dayjs(fileName.lastModifiedDate).format("hh:mm:ss") + fileName.name

        const formData = new FormData();
        formData.append("file", fileName);
        formData.append("imageName", fileNameData);

        swal({
            title: "Are you sure?",
            text: attachementMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiPostForImage({
                    url: endpoint.uploadImage,
                    postBody: formData,
                }).then(({ data, success }) => {

                    if (success) {
                        const newRow = {
                            index: rows.length + 1,
                            fileName: data,
                            docName: fileName.name,
                        };

                        showNotification({ msg: attachementSuccessMsg });

                        const updatedList = normalClaimListData.map((dataObj) => {
                            if (dataObj.id === rowId) {
                                return {
                                    ...dataObj,
                                    attachFile: fileNameData,
                                };
                            }
                            return dataObj;
                        });

                        this.setState({
                            rows: [...rows, newRow],
                            normalClaimListData: updatedList,
                            attachmentPopUpFlag: false,
                        });

                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });
            }
        });
    };

    onSearch = async () => {
        const { showLoador, showNotification } = this.props;
        const { claimType, fieldData } = this.state;
        if (navigator.onLine) {

            if (this.checkValidationOnSubmit() && this.dateComparisonCheck()) {

                let fromDate = dayjs(fieldData.fromDate).format("DD-MM-YYYY");
                let toDate = dayjs(fieldData.toDate).format("DD-MM-YYYY");

                this.setState({
                    salesTeamId: fieldData.salesTeamId,
                    fromDate: fromDate,
                    toDate: toDate,
                    claimType: fieldData.claimType,
                });

                showLoador({ loador: true });
                await apiGet({
                    url:
                        endpoint.claimApplyHeader + "/claim-data-between-dates-by-flag?fromDate="
                        + fromDate + "&toDate=" + toDate + "&salesTeamId=" + fieldData.salesTeamId
                        + "&flag=" + fieldData.claimType,
                }).then(({ data, success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error", });
                    } else {
                        if (Object.keys(data.data).length !== 0) {

                            const rowData = data.data;

                            const MatrixData = rowData.dates.map((d) => {
                                const matchedClaim = rowData.claimList.find((c) => c.dmyDate == d.dates);

                                const matchedDaBeatObj =
                                    d.workingBeatsWithCalculation?.find(
                                        (beat) => beat.id == matchedClaim?.daBeatId
                                    ) || null;


                                // Store original non-working beats with mapped names first
                                const originalNonWorkingBeats = d.nonWorkingBeatsWithCalculation?.map((beat) => ({
                                    ...beat,
                                    name: beat.visitedFlag == 1 ? beat.beatName + " - Visited" : beat.beatName,
                                })) || [];

                                // Filter from the original list if daBeat is matched
                                const filteredNonWorkingBeats = matchedDaBeatObj?.townId
                                    ? originalNonWorkingBeats.filter(
                                        (beat) => beat.townId == matchedDaBeatObj.townId
                                    )
                                    : originalNonWorkingBeats;


                                return {
                                    ...d,
                                    ...(matchedClaim || {}),
                                    selectedDaBeat: matchedClaim?.daBeatId || "",
                                    selectedDaBeatAmt: matchedClaim?.daClaimAmount || 0,
                                    selectedTaBeat: matchedClaim?.taBeatId || "",
                                    selectedTaBeatAmt: matchedClaim?.taClaimAmount || 0,
                                    totalClaimAmt: matchedClaim?.totalClaimAmt || 0,
                                    distanceFromHq: matchedClaim?.distanceFromHq || 0,
                                    isChecked: false,
                                    isZeroAmtOnTaBeatError: false,
                                    isManuallyEdited: matchedClaim?.isManuallyEdited || 0,
                                    manuallyEditedBeatName: matchedClaim?.manuallyEditedBeatName || matchedClaim?.taBeatName,
                                    manuallyEditedDistance: matchedClaim?.manuallyEditedDistance || matchedClaim?.distanceFromHq || 0,
                                    manuallyEditedClaimAmount: matchedClaim?.manuallyEditedClaimAmount || matchedClaim?.taClaimAmount || 0,

                                    workingBeatsWithCalculation:
                                        d.workingBeatsWithCalculation?.map((beat) => ({
                                            ...beat,
                                            name: beat.visitedFlag == 1 ? beat.beatName + " - Visited" : beat.beatName,
                                        })) || [],

                                    nonWorkingBeatsWithCalculation: filteredNonWorkingBeats,

                                    originalNonWorkingBeatsWithCalculation: originalNonWorkingBeats,
                                };
                            });

                            const normalClaimListData = rowData.normalClaimList.map((dataObj, index) => {
                                const allClaimStructureDetails = dataObj.claimStructureDetails !== null ?
                                    dataObj.claimStructureDetails.map((detailsObj, index) => ({
                                        index: index + 1,
                                        id: detailsObj.id !== null ? detailsObj.id : "",
                                        claim_id: detailsObj.claim_id !== null ? detailsObj.claim_id : "",
                                        claimApplyHeaderId: detailsObj.claimApplyHeaderId !== null ? detailsObj.claimApplyHeaderId : "",
                                        name: detailsObj.claimName !== null ? detailsObj.claimName : "",
                                        claimName: detailsObj.claimName !== null ? detailsObj.claimName : "",
                                        flag: detailsObj.flag !== null ? detailsObj.flag : "",
                                    })) : [];

                                const currentClaimApplyHeaderId = dataObj.claimApplyHeaderId !== null ? dataObj.claimApplyHeaderId : "";
                                const claimStructureDetails = allClaimStructureDetails.filter(
                                    (claimObj) => String(claimObj.claimApplyHeaderId) === String(currentClaimApplyHeaderId)
                                );
                                const defaultClaimTypeObj = claimStructureDetails.find(
                                    (claimObj) => claimObj.flag == 1
                                );

                                return {
                                    index: index + 1,
                                    id: dataObj.id !== null ? dataObj.id : "",
                                    date: dataObj.date !== null ? dayjs(dataObj.date).format("DD-MM-YYYY") : "",
                                    claimApplyHeaderId: currentClaimApplyHeaderId,
                                    selectedClaimId: defaultClaimTypeObj?.id || "",
                                    selectedClaimTypeId: defaultClaimTypeObj?.claim_id || "",
                                    claimTypeName: defaultClaimTypeObj?.name || "",
                                    editedClaimAmt: dataObj.editedClaimAmt !== null ? dataObj.editedClaimAmt : "",
                                    claimAmt: dataObj.claimAmt !== null ? dataObj.claimAmt : "",
                                    actualAmt: dataObj.actualAmt !== null ? dataObj.actualAmt : "",
                                    attachmentApplicable: dataObj.attachmentApplicable !== null ? dataObj.attachmentApplicable : "",
                                    attachFile: dataObj.attachFile !== null ? dataObj.attachFile : null,
                                    isChecked: false,
                                    claimStructureDetails,
                                }
                            });

                            const ratePerKm = rowData.ratePerKm || 0;

                            this.setState({ matrixDataList: MatrixData, normalClaimListData, ratePerKm });
                        }
                    }
                });
                showLoador({ loador: false });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    handleAllCheckedClick = (e) => {
        const { matrixDataList } = this.state;
        this.setState({ selection: e });
        this.setState({ allChecked: e.target.checked });
        let dataList = matrixDataList.map((dataObj) => {
            return {
                ...dataObj,
                isChecked: e.target.checked,
            };
        });
        this.setState({ matrixDataList: dataList });
    };


    handleAllCheckedClickForNormalClaim = (e) => {
        const { normalClaimListData } = this.state;
        this.setState({ allChecked: e.target.checked });
        let dataList = normalClaimListData.map((dataObj) => {
            return {
                ...dataObj,
                isChecked: e.target.checked,
            };
        });
        this.setState({ normalClaimListData: dataList });
    };


    handleDateChange = (newDate, id) => {
        const { normalClaimListData } = this.state;

        const updatedList = normalClaimListData.map((dataObj) => {
            if (dataObj.id === id) {
                return {
                    ...dataObj,
                    date: newDate ? newDate.format("DD-MM-YYYY") : null
                };
            }
            return dataObj;
        });

        this.setState({ normalClaimListData: updatedList });
    }


    checkValidationOnSubmitForDetails = () => {
        const { normalClaimListData } = this.state;
        let formErrorForDetails = {};
        let formIsValid = true;
        let errorMessage = "This field is required";
        let canNotBeZeroMessage = "Amount cannot be zero";

        normalClaimListData.filter((item) => item.isChecked).map((item) => {
            if (item.editedClaimAmt === "" || item.editedClaimAmt === null) {
                formIsValid = false;
                formErrorForDetails[`editedClaimAmtError${item.id}`] = errorMessage;
            } else if (item.editedClaimAmt === 0) {
                formIsValid = false;
                formErrorForDetails[`editedClaimAmtError${item.id}`] = canNotBeZeroMessage;
            }
        });

        this.setState({ formErrorForDetails });
        return formIsValid;
    };


    onChangeTextField = (e, id) => {
        const { name, value } = e.target;

        this.setState((prev) => {
            const updatedList = prev.normalClaimListData.map((item) =>
                item.id == id ? { ...item, [name]: value } : item
            );

            const errorKey = `${name}Error${id}`;
            const updatedErrors = { ...(prev.formErrorForDetails || {}) };

            if (updatedErrors[errorKey]) {
                delete updatedErrors[errorKey];
            }

            return {
                normalClaimListData: updatedList,
                formErrorForDetails: updatedErrors,
            };
        });
    };

    onNormalClaimTypeChange = (rowId) => (name, newValue) => {
        this.setState((prev) => {
            const updatedList = prev.normalClaimListData.map((item) => {
                if (item.id == rowId) {
                    const selectedClaimType = item.claimStructureDetails?.find(
                        (claimObj) =>
                            claimObj.id == newValue &&
                            String(claimObj.claimApplyHeaderId) == String(item.claimApplyHeaderId)
                    );

                    return {
                        ...item,
                        selectedClaimId: newValue || "",
                        selectedClaimTypeId: selectedClaimType?.claim_id || "",
                        claimTypeName: selectedClaimType?.name || "",
                    };
                }
                return item;
            });

            return { normalClaimListData: updatedList };
        });
    };

    handleAddClick = (e, id) => {

        this.setState({ attachmentPopUpFlag: true, rowId: id });
    }

    onAutocompleteChange = (teamId) => (name, newValue) => {
        const { matrixDataList } = this.state;
        const updatedMatrixData = matrixDataList.map((item) => {
            if (item.id == teamId) {
                if (name == "daBeat") {
                    const matchedDaBeatObj =
                        item.workingBeatsWithCalculation?.find(
                            (beat) => beat.id == newValue
                        ) || null;

                    const newDaAmt = matchedDaBeatObj?.dailyAllowance || 0;
                    const currentTaAmt = item.selectedTaBeatAmt || 0;

                    // Use original list (stored separately) for filtering
                    const originalNonWorkingBeats = item.originalNonWorkingBeatsWithCalculation || item.nonWorkingBeatsWithCalculation || [];

                    // Filter from the original list based on townId
                    const filteredNonWorkingBeats = matchedDaBeatObj?.townId
                        ? originalNonWorkingBeats.filter(
                            (beat) => beat.townId == matchedDaBeatObj.townId
                        )
                        : originalNonWorkingBeats;

                    // Check if current TA beat is still valid
                    const isTaBeatValid = filteredNonWorkingBeats.some(beat => beat.id == item.selectedTaBeat);

                    return {
                        ...item,
                        selectedDaBeat: newValue,
                        selectedDaBeatAmt: newDaAmt,
                        daClaimAmount: newDaAmt,
                        // Store original list if not already stored
                        originalNonWorkingBeatsWithCalculation: item.originalNonWorkingBeatsWithCalculation || item.nonWorkingBeatsWithCalculation,
                        // Update with filtered list
                        nonWorkingBeatsWithCalculation: filteredNonWorkingBeats,
                        // Reset TA beat selection if it's no longer in the filtered list
                        selectedTaBeat: isTaBeatValid ? item.selectedTaBeat : null,
                        selectedTaBeatAmt: isTaBeatValid ? item.selectedTaBeatAmt : 0,
                        taClaimAmount: isTaBeatValid ? item.taClaimAmount : 0,
                        distanceFromHq: isTaBeatValid ? item.distanceFromHq : 0,
                        manuallyEditedBeatName: isTaBeatValid ? item.taBeatName : "",
                        manuallyEditedDistance: isTaBeatValid ? item.manuallyEditedDistance : 0,
                        manuallyEditedClaimAmount: isTaBeatValid ? item.taClaimAmount : 0,
                        totalClaimAmt: newDaAmt + (isTaBeatValid ? currentTaAmt : 0),
                    };
                } else if (name == "taBeat") {

                    const matchedTaBeatObj =
                        item.nonWorkingBeatsWithCalculation?.find(
                            (beat) => beat.id == newValue
                        ) || null;

                    const newTaAmt = matchedTaBeatObj?.travelAllowance || 0;
                    const currentDaAmt = item.selectedDaBeatAmt || 0;

                    return {
                        ...item,
                        selectedTaBeat: newValue,
                        selectedTaBeatAmt: newTaAmt,
                        taClaimAmount: newTaAmt,
                        totalClaimAmt: currentDaAmt + newTaAmt,
                        distanceFromHqForTaBeat: matchedTaBeatObj?.distanceFromHq || 0,
                        isZeroAmtOnTaBeatError: newValue && newTaAmt == 0 ? true : false,
                        distanceFromHq: matchedTaBeatObj?.distanceFromHq || 0,
                        manuallyEditedBeatName: matchedTaBeatObj?.beatName || "",
                        manuallyEditedDistance: matchedTaBeatObj?.distanceFromHq || 0,
                        manuallyEditedClaimAmount: matchedTaBeatObj?.travelAllowance || 0,
                    };
                }
            }
            return item;
        });

        this.setState({ matrixDataList: updatedMatrixData });
    };
    changeHandler = (row, fieldName) => (e) => {

        const { ratePerKm } = this.state;
        const value = e.target.value;
        const isTA = fieldName === "manuallyEditedClaimAmount";
        const isDistance = fieldName === "manuallyEditedDistance";
        const numericValue = parseFloat(value) || 0;
        const errorMsg = !value ? thisFieldIsRequiredMsg : "";

        this.setState((prevState) => {
            const updatedList = prevState.matrixDataList.map((item) => {
                if (item.id !== row.id) return item; // skip untouched items

                const updatedItem = {
                    ...item,
                    [fieldName]: value,
                    [`${fieldName}Error`]: errorMsg,
                };

                if (isTA) {
                    updatedItem.selectedTaBeatAmt = numericValue;
                    updatedItem.totalClaimAmt = (parseFloat(item.daClaimAmount) || 0) + numericValue;
                }

                if (isDistance) {
                    updatedItem.selectedTaBeatAmt = numericValue * ratePerKm;
                    updatedItem.taClaimAmount = numericValue * ratePerKm;
                    updatedItem.manuallyEditedClaimAmount = numericValue * ratePerKm;
                    updatedItem.totalClaimAmt = (parseFloat(item.daClaimAmount) || 0) + (numericValue * ratePerKm);
                }

                return updatedItem;
            });

            return { matrixDataList: updatedList };
        });
    };

    changeRadioHandler = (event, id) => {
        const selectedType = Number(event.target.value);
        const { ratePerKm } = this.state;

        this.setState((prevState) => ({
            matrixDataList: prevState.matrixDataList.map((item) => {
                if (item.id !== id) return item;

                if (selectedType === 0) {
                    // Switching to Normal: use original beat-based DA + TA amounts
                    const normalTotal =
                        (parseFloat(item.daClaimAmount) || 0) +
                        (item.distanceFromHq * ratePerKm || 0);

                    return {
                        ...item,
                        isManuallyEdited: 0,
                        selectedTaBeatAmt: ratePerKm * item.distanceFromHq || 0,
                        taClaimAmount: ratePerKm * item.distanceFromHq || 0,
                        totalClaimAmt: normalTotal,
                    };
                } else {
                    // Switching to Manual: compute TA from manuallyEditedDistance * ratePerKm
                    const manualDistance = parseFloat(item.manuallyEditedDistance) || 0;
                    const manualTaAmt = manualDistance > 0
                        ? manualDistance * ratePerKm
                        : (parseFloat(item.manuallyEditedClaimAmount) || 0);

                    const manualTotal =
                        (parseFloat(item.daClaimAmount) || 0) + manualTaAmt;

                    return {
                        ...item,
                        isManuallyEdited: 1,
                        selectedTaBeatAmt: manualTaAmt,
                        taClaimAmount: manualTaAmt,
                        totalClaimAmt: manualTotal,
                    };
                }
            }),
        }));
    };


    handleCheckBoxClick = (e, id) => {
        const { matrixDataList } = this.state;
        this.setState({ selection: e });
        let data = matrixDataList.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isChecked: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        this.setState({ matrixDataList: data });
    };

    handleCheckBoxClickForNormalClaim = (e, id) => {
        const { normalClaimListData } = this.state;
        let data = normalClaimListData.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isChecked: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        this.setState({ normalClaimListData: data });
    };

    handleStatusChange = (teamId, flag) => {
        const { salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }
        swal({
            title: "Are you sure?",
            text: flag == 3 ? rejectClaimMsg : approveClaimMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiGet({
                    url:
                        endpoint.claimApplyHeader +
                        "/update-status?claimApplyHeaderId=" +
                        teamId +
                        "&status=" +
                        flag,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        this.props.showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({ msg: statusmsg });
                        this.onSearch(rowData);
                    }
                });
            }
        });
    };

    clickSubmitHandler = async () => {
        const { matrixDataList } = this.state;
        const { showNotification } = this.props;

        let hasErrors = false;

        const finalDataList =
            matrixDataList.filter((dataObj) => dataObj.isChecked).map((dataObj) => ({
                ...dataObj,
            }));


        if (finalDataList.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }


        hasErrors = finalDataList.some(
            (row) =>
                !!row.manuallyEditedBeatNameError ||
                !!row.manuallyEditedDistanceError ||
                !!row.manuallyEditedClaimAmountError
        );

        if (hasErrors) {
            return showNotification({ msg: checkRequiredFieldsMsg, severity: "error" });
        }



        const invalidDates = matrixDataList
            .filter((row) => row.isChecked &&
                (row.selectedDaBeat == null || row.selectedDaBeat == "") &&
                (row.selectedTaBeat == null || row.selectedTaBeat == "")
            ).map((dataObj) => dataObj.dates);

        if (invalidDates.length == 1) {
            return showNotification({ msg: `Please select at least one beat on ${invalidDates[0]}`, severity: 'error' });
        } else if (invalidDates.length > 1) {
            return showNotification({ msg: `Please select at least one beat on these dates: ${invalidDates.join(", ")}`, severity: 'error' });
        }


        const finalSaveList = finalDataList.map((dataObj) => {
            return {
                dates: dataObj.dates !== null ? dataObj.dates : "",
                selectedDate: dataObj.selectedDate !== null ? dataObj.selectedDate : "",
                daClaimAmount: (dataObj.selectedDaBeatAmt && dataObj.selectedDaBeatAmt !== null)
                    ? dataObj.selectedDaBeatAmt : 0,
                daBeatId: (dataObj.selectedDaBeat && dataObj.selectedDaBeat !== null)
                    ? dataObj.selectedDaBeat : null,
                taClaimAmount: (dataObj.selectedTaBeatAmt && dataObj.selectedTaBeatAmt !== null)
                    ? dataObj.selectedTaBeatAmt : 0,
                taBeatId: (dataObj.selectedTaBeat && dataObj.selectedTaBeat !== null)
                    ? dataObj.selectedTaBeat : null,
                distanceFromHq: (dataObj.distanceFromHqForTaBeat && dataObj.distanceFromHqForTaBeat !== null)
                    ? dataObj.distanceFromHqForTaBeat : 0,
                isZeroAmtOnTaBeatError: (
                    dataObj.isZeroAmtOnTaBeatError && dataObj.isZeroAmtOnTaBeatError !== null)
                    ? dataObj.isZeroAmtOnTaBeatError : false,
                claimApplyHeaderId: dataObj.id !== null ? dataObj.id : "",
                manuallyEditedBeatName: dataObj.manuallyEditedBeatName ? dataObj.manuallyEditedBeatName : null,
                manuallyEditedDistance: dataObj.manuallyEditedDistance ? dataObj.manuallyEditedDistance : null,
                manuallyEditedClaimAmount: dataObj.manuallyEditedClaimAmount ? dataObj.manuallyEditedClaimAmount : 0,
                isManuallyEdited: dataObj.isManuallyEdited ? dataObj.isManuallyEdited : 0,
            }
        });

        this.onSave(finalSaveList);
    }

    onSaveForNormalClaim = async () => {
        const { normalClaimListData, salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const finalDataList =
            normalClaimListData.filter((dataObj) => dataObj.isChecked).map((dataObj) => ({
                ...dataObj,
            }));

        if (finalDataList.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        if (this.checkValidationOnSubmitForDetails()) {

            const finalSaveList = finalDataList.map((dataObj) => {
                return {
                    id: dataObj.id !== null ? dataObj.id : "",
                    date: dataObj.date !== null ?
                        dayjs(dataObj.date, ["DD-MM-YYYY", "YYYY-MM-DD", "MMM DD YYYY"]).format("YYYY-MM-DD") : "",
                    claimApplyHeaderId: dataObj.claimApplyHeaderId !== null ? dataObj.claimApplyHeaderId : "",
                    claimTypeId: dataObj.selectedClaimTypeId !== null ? dataObj.selectedClaimTypeId : "",
                    claimAmt: dataObj.editedClaimAmt !== null ? dataObj.editedClaimAmt : "",
                    attachFile: dataObj.attachFile !== null ? dataObj.attachFile : "",
                }
            });

            const rowData = {
                salesTeamId: salesTeamId,
                fromDate: fromDate,
                toDate: toDate,
            }

            swal({
                title: "Are you sure?",
                text: saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url:
                            endpoint.claimApplyHeader + "/submit-normal-claim-data",
                        postBody: finalSaveList,
                    }).then(({ success }) => {
                        if (success) {
                            showNotification({
                                msg: savemsg,
                            });
                            this.onSearch(rowData);
                        } else {
                            showNotification({
                                msg: saveFailedMsg,
                                severity: "error",
                            });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        }

    }

    clickDeleteHandler = async () => {
        const { matrixDataList, salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }

        const finalDataList =
            matrixDataList.filter((dataObj) => dataObj.isChecked).map((dataObj) => ({
                ...dataObj,
            }));


        if (finalDataList.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        let claimApplyHeaderIds = finalDataList.map(item => item.id).join(",");

        swal({
            title: "Are you sure?",
            text: deleteWarningMsgForClaim,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiDelete({
                    url: endpoint.claimApplyHeader + "/delete-claim-by-ids?claimApplyHeaderIds=" + claimApplyHeaderIds,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (data.data.error == false) {
                        showNotification({ msg: deletemsg, severity: "success" });
                        this.onSearch(rowData);
                    } else {
                        showNotification({ msg: deleteFailedMsg, severity: "error" });
                    }
                });
            }
        });
    }


    clickApproveHandler = async () => {
        const { matrixDataList, salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }

        const finalDataListForApprovrClaim =
            matrixDataList.filter((dataObj) => dataObj.isChecked && dataObj.status == 0).map((dataObj) => ({
                ...dataObj,
            }));


        if (finalDataListForApprovrClaim.length == 0) {
            return showNotification({ msg: selectPendingClaimMsg, severity: "error" });
        }

        let claimApplyHeaderIdsList = finalDataListForApprovrClaim.map(item => item.id);

        let dataToSendForApproval = {
            claimApplyHeaderIds: claimApplyHeaderIdsList,
            status: 2,
        }

        swal({
            title: "Are you sure?",
            text: approveClaimMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiPost({
                    url: endpoint.claimApplyHeader + "/update-status-by-headers",
                    postBody: dataToSendForApproval
                }).then(({ data, success }) => {
                    if (data.data.error == false) {
                        showNotification({ msg: approvedSuccessfullyMsg, severity: "success" });
                        this.onSearch(rowData);
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });
            }
        });
    }

    clickRejectHandler = async () => {
        const { matrixDataList, salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }

        const finalDataListForApprovrClaim =
            matrixDataList.filter((dataObj) => dataObj.isChecked && dataObj.status == 0).map((dataObj) => ({
                ...dataObj,
            }));

        if (finalDataListForApprovrClaim.length == 0) {
            return showNotification({ msg: selectPendingClaimMsg, severity: "error" });
        }

        let claimApplyHeaderIdsList = finalDataListForApprovrClaim.map(item => item.id);

        let dataToSendForApproval = {
            claimApplyHeaderIds: claimApplyHeaderIdsList,
            status: 3,
        }
        swal({
            title: "Are you sure?",
            text: rejectClaimMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiPost({
                    url: endpoint.claimApplyHeader + "/update-status-by-headers",
                    postBody: dataToSendForApproval
                }).then(({ data, success }) => {
                    if (data.data.error == false) {
                        showNotification({ msg: rejectedSuccessfullyMsg, severity: "success" });
                        this.onSearch(rowData);
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });
            }
        });
    }


    onDeleteForNormalClaim = async () => {
        const { normalClaimListData, salesTeamId, fromDate, toDate } = this.state;
        const { showLoador, showNotification } = this.props;

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }

        const finalDataList =
            normalClaimListData.filter((dataObj) => dataObj.isChecked).map((dataObj) => ({
                ...dataObj,
            }));

        if (finalDataList.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        let claimApplyDetailIds = finalDataList.map(item => item.id).join(",");

        swal({
            title: "Are you sure?",
            text: deleteWarningMsgForClaim,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                await apiDelete({
                    url: endpoint.claimApplyHeader + "/delete-claim-details-by-ids?claimApplyDetailIds=" + claimApplyDetailIds,
                }).then(({ data, success }) => {
                    if (data.data.error == false) {
                        showNotification({ msg: deletemsg, severity: "success" });
                        this.onSearch(rowData);
                    } else {
                        showNotification({ msg: deleteFailedMsg, severity: "error" });
                    }
                });
                showLoador({ loador: false });
            }
        });
    }

    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;

        if (fieldName == "claimType") {
            this.setState({ matrixDataList: [] });
        }

        AllowanceWiseClaimManagementJson.fieldMeta.map((currentField) => {
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");

                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });

                this.getListById(dataToSearch);
            }
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };

    onSave = (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        const { salesTeamId, fromDate, toDate } = this.state;

        const isZeroTaAmtPresent = dataToSave.some((row) => row.isZeroAmtOnTaBeatError);

        const rowData = {
            salesTeamId: salesTeamId,
            fromDate: fromDate,
            toDate: toDate,
        }

        swal({
            title: "Are you sure?",
            text: isZeroTaAmtPresent ? saveWarningMsgForClaimManagement : saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });

                await apiPost({
                    url:
                        endpoint.claimApplyHeader + "/submit-claim-data-with-flag?salesTeamId=" + salesTeamId,
                    postBody: dataToSave,
                }).then(({ data, success }) => {

                    if (
                        Object.keys(data.data).length !== 0
                        && data?.data?.error
                    ) {
                        showNotification({
                            msg: data?.data?.message || saveFailedMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({
                            msg: savemsg,
                        });
                        this.onSearch(rowData);
                    }
                });

                showLoador({ loador: false });
            }
        });
    }

    handleCloses = () => {
        this.setState({ attachmentPopUpFlag: false });
    }

    render() {
        const {
            dynamicMasterData,
            matrixDataList,
            claimType,
            fieldData,
            formErrors,
            normalClaimListData,
            attachmentPopUpFlag,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        showTitle={AllowanceWiseClaimManagementJson.showTitle}
                        screenTitle={AllowanceWiseClaimManagementJson.screenTitle}
                        fieldMeta={AllowanceWiseClaimManagementJson.fieldMeta}
                        apiBaseURL={AllowanceWiseClaimManagementJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={true}
                        saveBtnText={"Search"}
                        showSaveNextBtn={false}
                        showSaveBtnMain={false}
                        onFormSave={this.onSearch}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={false}
                    />

                    {fieldData?.claimType == 1 ? (
                        <>
                            {matrixDataList.length !== 0 && (
                                <AllowanceWiseClaimManagementTable
                                    handleAllCheckedClick={this.handleAllCheckedClick}
                                    clickSubmitHandler={this.clickSubmitHandler}
                                    clickDeleteHandler={this.clickDeleteHandler}
                                    clickRejectHandler={this.clickRejectHandler}
                                    clickApproveHandler={this.clickApproveHandler}
                                    allChecked={this.state.allChecked}
                                    matrixDataList={matrixDataList}
                                    handleCheckBoxClick={this.handleCheckBoxClick}
                                    onAutocompleteChange={this.onAutocompleteChange}
                                    changeHandler={this.changeHandler}
                                    changeRadioHandler={this.changeRadioHandler}
                                    handleStatusChange={this.handleStatusChange}
                                />
                            )}
                        </>
                    ) :
                        (
                            <>
                                {normalClaimListData.length !== 0 && (
                                    <NormalClaimManagementTable
                                        handleAllCheckedClick={this.handleAllCheckedClickForNormalClaim}
                                        onSaveForNormalClaim={this.onSaveForNormalClaim}
                                        onDeleteForNormalClaim={this.onDeleteForNormalClaim}
                                        allChecked={this.state.allChecked}
                                        normalClaimListData={normalClaimListData}
                                        handleCheckBoxClick={this.handleCheckBoxClickForNormalClaim}
                                        handleDateChange={this.handleDateChange}
                                        onChangeTextField={this.onChangeTextField}
                                        onNormalClaimTypeChange={this.onNormalClaimTypeChange}
                                        formErrorForDetails={this.state.formErrorForDetails}
                                        handleAddClick={this.handleAddClick}
                                    />
                                )}
                            </>
                        )}

                    {attachmentPopUpFlag && (
                        <AttachementPopUp
                            open={attachmentPopUpFlag}
                            handleCloses={this.handleCloses}
                            formErrors={this.state.formErrors}
                            onAddImage={this.onAddImage}
                        />
                    )}
                </Paper >
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesPersonList: state.salesExecutive,
});
const mapDispatchToProps = {
    getAllSalesExecutiveByUserType,
    showLoador,
    showNotification,
    getBelowSalesTeamList,
};
export default connect(mapStateToProps, mapDispatchToProps)(AllowanceWiseClaimManagement);
